import React from "react";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AnimatedCursor from "react-animated-cursor";
import styled from "styled-components";
import Footer from "./components/Footer";
import PageNotFound from "./pages/404";
import ScrollToTop from "./hooks/ScrollToTop";
import LoadingPage from "./pages/LoadingPage";

function App() {
  return (
    <div className="App">
      {document.readyState !== "interactive" &&
      document.readyState !== "complete" ? (
        <LoadingPage />
      ) : (
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      )}

      <Analytics />
    </div>
  );
}

const AppContent = () => {
  return (
    <div>
      <AnimatedCursor color="0, 90, 224" />

      <StyledContent>
        <Routes>
          <Route path="/" element={<NewPortfolioPlaceholder />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </StyledContent>
      <Footer />
    </div>
  );
};

const NewPortfolioPlaceholder = () => {
  const [currentImage, setCurrentImage] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % 6);
    }, 2700);

    return () => clearInterval(interval);
  }, []);

  return (
    <NewPortfolioContainer>
      <NewPortfolioHeroContainer>
        <ContentWrapper>
          <LogoImage
            src="/tiffanychan.png"
            height="64px"
            width="164px"
            alt="Tiffany Chan"
          />
          <ImageWithFrame>
            <AnimatedImage
              src={`/tiff2025-${currentImage}.png`}
              alt="Tiffany"
            />
            <FrameOverlay src="/frame.svg" alt="" />
          </ImageWithFrame>

          <Cloud1Video
            src="/cloud1.mov"
            width={120}
            height={75}
            autoPlay
            muted
            loop
            playsInline
          />
          <Cloud2Video
            src="/cloud2.mov"
            width={120}
            height={75}
            autoPlay
            muted
            loop
            playsInline
          />
          <h1>Designer and sometimes-builder of software.</h1>
          <h1>
            Currently building tech for public good at{" "}
            <i>Open Government Products</i>.
          </h1>
          <h1>
            Lover of <i>solo</i> travelling, yummy <i>typography</i> and{" "}
            <i>lattes.</i>
          </h1>
        </ContentWrapper>
      </NewPortfolioHeroContainer>
    </NewPortfolioContainer>
  );
};

export default App;

const StyledContent = styled.div`
  position: relative;
  z-index: 99;
  background-color: #005ae0;
  margin-bottom: 520px;

  @media (max-width: 640px) {
    margin-bottom: 540px;
  }
`;

const NewPortfolioContainer = styled.div`
  padding: 1rem;
  text-align: center;
  font-family: "Instrument Serif", serif !important;
  background-color: #005ae0;
  * {
    font-family: "Instrument Serif", serif !important;
    color: #005ae0;
  }

  h1 {
    font-family: "Instrument Serif", serif !important;
    font-weight: 400;

    font-size: 56px;
    letter-spacing: -2px;
    line-height: 105%;
    margin-block-start: 1rem;
    margin-block-end: 1rem;
  }

  p,
  a {
    font-family: "Geist Mono" !important;
    margin: 0;
  }

  @media (max-width: 640px) {
    h1 {
      font-size: 40px;
    }
  }
`;

const NewPortfolioHeroContainer = styled.div`
  background-color: #f2eee2;
  border-radius: 30px;
  padding: 1.5rem;
  padding-bottom: 2.5rem;

  @media (max-width: 640px) {
    padding: 1rem;
  }
`;

const ImageWithFrame = styled.div`
  position: relative;
  display: inline-block;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
`;

const AnimatedImage = styled.img`
  position: relative;
  transition: all 0.3s ease;
  height: 420px;
  width: 327px;
  object-fit: cover;
  transform: rotate(-4deg) @media (max-width: 500px) {
    width: 100%;
    height: auto;
    aspect-ratio: 3 / 4;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: rotate(1deg);
    }
  }
`;

const FrameOverlay = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 387px;
  height: 450px;
  z-index: 1;
  transition: all 0.3s ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: translate(-50%, -50%) rotate(5deg);
    }
  }
`;

const ContentWrapper = styled.div`
  max-width: 650px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoImage = styled.img`
  margin-bottom: 1rem;
`;

const Cloud1Video = styled.video`
  position: absolute;
  left: 25%;
  top: 40%;

  @media (max-width: 1200px) {
    left: 12%;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
const Cloud2Video = styled.video`
  position: absolute;
  right: 23%;
  top: 20%;

  @media (max-width: 1200px) {
    right: 12%;
  }

  @media (max-width: 768px) {
    position: static;
    margin-bottom: 16px;
  }
`;
